import { render, staticRenderFns } from "./GrossPayChart.vue?vue&type=template&id=3bd5dbf6&scoped=true"
import script from "./GrossPayChart.vue?vue&type=script&lang=js"
export * from "./GrossPayChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5dbf6",
  null
  
)

export default component.exports